import { useState, useEffect, useCallback } from 'react';
import apiClient from '../../Api/axiosConfig';
import set from 'lodash/set'; // Csak a 'set' funkciót importáljuk
import cloneDeep from 'lodash/cloneDeep'; // A megbízható mély másoláshoz

export const useAdminData = () => {
  const [formData, setFormData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  const fetchData = useCallback(() => {
    setIsLoading(true);
    apiClient.get('/data/secure')
      .then(response => {
        setFormData(response.data);
      })
      .catch(() => setError('Hiba az adatok betöltésekor.'))
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // <<< ITT VAN A VÉGLEGES, LODASH-ALAPÚ JAVÍTÁS >>>
  const handleFormChange = (path, value) => {
    setFormData(prevData => {
      const newData = cloneDeep(prevData);
      console.log("value:", value);  //ITT MÉG JÓ
      set(newData, path, value);
      return newData;
    });
  };

  const handleSave = async (dataToSave) => {
    setIsSaving(true);
    setError('');
    setSuccess('');
    try {
      const payload = dataToSave || formData;
      console.log(payload);
      await apiClient.post('/data/save', payload).then((result) => { console.log(result); });
      setFormData(payload);
      setSuccess('Adatok sikeresen mentve!');
      fetchData();
    } catch (err) {
      setError('Hiba a mentés során.');
    } finally {
      setIsSaving(false);
      setTimeout(() => setSuccess(''), 3000);
    }
  };

  return { formData, isLoading, isSaving, error, success, handleFormChange, handleSave };
};